import { render, staticRenderFns } from "./vehicle-box-medium.vue?vue&type=template&id=7096bbeb&scoped=true&lang=pug&"
import script from "./vehicle-box-medium.vue?vue&type=script&lang=js&"
export * from "./vehicle-box-medium.vue?vue&type=script&lang=js&"
import style0 from "./vehicle-box-medium.vue?vue&type=style&index=0&id=7096bbeb&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7096bbeb",
  null
  
)

export default component.exports